/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isImage } from "../../utils";

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    src: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

class DocumentModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { isOpen, src, onClose, title } = this.props;
        if (isOpen) {
            return (
                <div className="document-modal">
                    <div className="document-modal__inner">
                        <div
                            className={
                                isImage(src)
                                    ? 'document-modal__inner-wrap-image'
                                    : 'document-modal__inner-wrap-iframe'
                            }
                        >
                            <div className="document-modal__header">
                                <div className="document-modal__header-title">
                                    {title}
                                </div>

                                <div className="document-modal__header-icons">
                                    <a
                                        href={src}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <i className="icon icon-download-2" />
                                    </a>
                                    <i
                                        onClick={onClose}
                                        className="icon icon-close2"
                                    />
                                </div>
                            </div>
                            {isImage(src) ? (
                                <div className="document-modal__image-content">
                                    <img src={src} />
                                </div>
                            ) : (
                                <div className="document-modal__iframe-content">
                                    <iframe src={src} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }
}

DocumentModal.propTypes = propTypes;

export default DocumentModal;
